var _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoGradient = function SvgLogoGradient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 256,
    viewBox: "0 0 512 256",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5093 245.286V184.279C56.7366 192.738 69.71 199.659 87.3539 199.659C123.42 199.659 147.551 171.463 147.551 133.269C147.551 95.8453 126.015 67.649 88.6512 67.649C69.4506 67.649 55.1798 76.1078 49.4715 85.8484V70.4686H16V245.286H50.5093ZM113.56 133.526C113.56 156.083 99.5489 169.156 81.9051 169.156C64.2612 169.156 49.9904 155.827 49.9904 133.526C49.9904 111.225 64.2612 98.1522 81.9051 98.1522C99.5489 98.1522 113.56 111.225 113.56 133.526Z",
    fill: "url(#lg_paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.09 169.412C188.225 169.412 172.657 157.108 172.657 133.526C172.657 109.687 188.225 97.6396 205.09 97.6396C221.956 97.6396 237.524 109.687 237.524 133.526C237.524 157.364 221.956 169.412 205.09 169.412ZM205.09 66.6236C166.948 66.6236 138.147 94.5636 138.147 133.526C138.147 172.232 166.948 200.428 205.09 200.428C243.232 200.428 272.033 172.232 272.033 133.526C272.033 94.5636 243.232 66.6236 205.09 66.6236Z",
    fill: "url(#lg_paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M393.838 11H359.847V83.0288C356.215 76.3642 345.836 67.3926 323.781 67.3926C287.715 67.3926 262.547 96.3579 262.547 133.269C262.547 171.463 288.494 199.659 324.819 199.659C341.944 199.659 354.918 191.969 360.626 181.972C360.626 187.868 361.404 194.02 361.923 196.583H394.876C394.357 191.456 393.838 182.229 393.838 173.77V11ZM297.316 133.269C297.316 110.712 311.327 97.8959 328.971 97.8959C346.615 97.8959 360.366 110.456 360.366 133.013C360.366 155.827 346.615 169.156 328.971 169.156C310.808 169.156 297.316 155.827 297.316 133.269Z",
    fill: "url(#lg_paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.25 161.466C394.807 175.82 408.04 200.428 446.441 200.428C479.913 200.428 496 179.409 496 158.902C496 140.447 483.286 125.323 458.118 120.197L439.955 116.352C432.949 115.07 428.279 111.225 428.279 105.073C428.279 97.8959 435.544 92.513 444.625 92.513C459.155 92.513 464.604 101.997 465.642 109.431L494.443 103.023C492.886 89.437 480.691 66.6236 444.366 66.6236C416.862 66.6236 396.623 85.3357 396.623 107.893C396.623 125.58 407.781 140.19 432.43 145.573L449.296 149.418C459.155 151.469 463.047 156.083 463.047 161.722C463.047 168.387 457.599 174.282 446.182 174.282C431.133 174.282 423.608 165.054 422.83 155.058L393.25 161.466Z",
    fill: "url(#lg_paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg_paint0_linear",
    x1: 529.92,
    y1: 29.9771,
    x2: -21.5282,
    y2: 126.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7156B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg_paint1_linear",
    x1: 529.92,
    y1: 29.9771,
    x2: -21.5282,
    y2: 126.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7156B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg_paint2_linear",
    x1: 529.92,
    y1: 29.9771,
    x2: -21.5282,
    y2: 126.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7156B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg_paint3_linear",
    x1: 529.92,
    y1: 29.9771,
    x2: -21.5282,
    y2: 126.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7156B"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoGradient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_gradient.e8913658.svg";
export { ForwardRef as ReactComponent };